export const filterMenuItems = (items, filterSegments) =>
  Object.keys(items).reduce(
    (acc, item) =>
      filterSegments(items[item].userSegments)
        ? { ...acc, [item]: { ...items[item] } }
        : acc,
    {}
  );
